<template>
<div class="modalContents__object01" data-modalContents="mainMenu">
    <div class="modalContents__object01__menu">
        <div class="modalContents__object01__menu__btn">
            <a href="javascript:void(0)" class="globalModal--btn" data-modal="mainMenuClose" title="close" @click='hideModal'>
                <span class="fa-stack fa-lg">
                    <i class="fa fa-circle-thin fa-stack-2x fa-inverse" aria-hidden="true"></i>
                    <i class="fa fa-times fa-stack-1x fa-inverse" aria-hidden="true"></i>
                </span>
            </a>
        </div>
        <h2>
            <!-- 以下のaタグを編集してください -->
            <a href="/" title="ニューズ・オプエド">
                <img src="/images/common/logo01.png" width="152" height="64" alt="ニューズ・オプエド 英字ロゴ">
                <img class="hidden-xs-down" src="/images/common/logo03.png" width="182" height="64" alt="ニューズ・オプエド 和文ロゴ">
            </a>
        </h2>
        <div class="modalContents__object01__menu__gate">
            <ul class="clearfix">
                <!-- 以下の各aタグを編集してください -->
                <li>
                    <!-- ログアウトボタンは表示されないようになっています -->
                    <!-- ログイン後にログアウトボタンが表示されるようにしてください -->
                    <a class="globalModal--btn" @click='showModalLogin' v-if="!isLogged" href="javascript:void(0)" title="ログイン"><i class="fa fa-chevron-circle-right"
                            aria-hidden="true"></i>Login</a>
                    <a class="modalContents__object01__menu__gate--logout" v-if="isLogged" href="/auth/logout" title="ログアウト"><i class="fa fa-chevron-circle-right"
                            aria-hidden="true"></i>Logout</a>
                </li>
                <li>
                    <!-- マイページボタンは表示されないようになっています -->
                    <!-- ログイン後にマイページボタンが表示されるようにしてください -->
                    <a class="globalModal--btn" @click='showModalMain'  v-if="!isLogged" data-modal="signup" href="javascript:void(0)" title="新規登録"><i class="fa fa-chevron-circle-right"
                            aria-hidden="true"></i>Sign Up</a>
                    <a class="modalContents__object01__menu__gate--mypage globalModal--btn" @click='showModalMypageTop' v-if="isLogged" data-modal="mypage" href="javascript:void(0)"
                        title="マイページ"><i class="fa fa-chevron-circle-right" aria-hidden="true"></i>My Page</a>
                </li>
            </ul>
        </div>
        <div class="modalContents__object01__menu__list">
            <ul>
                <!-- 以下の各aタグを編集してください -->
                <li><a href="/" title="ニューズ・オプエドトップページ">TOP</a></li>
                <li><a href="/about.html" title="ニューズ・オプエドとは">ABOUT</a></li>
                <li><a href="/video" title="動画一覧">VIDEOS</a></li>
                <li><a href="/performer" title="コメンテーター一覧">GUESTS</a></li>
                <li><a href="/news" title="ニュース一覧">NEWS</a></li>
                <li><a href="/sports" title="スポーツ一覧">SPORTS</a></li>
            </ul>
        </div>
        <div class="modalContents__object01__menu__sns">
            <!-- SNSのアイコンはデフォルトで5種類配置してあります（6種類まで追加可能です） -->
            <!-- 減らす場合は該当するliタグを全て消去してください -->
            <!-- 増やす場合は既存のliタグをコピーしてfontawesomeのアイコンを変更してください -->
            <ul class="d-flex justify-content-start">
                <li>
                    <!-- 以下のaタグを編集してください -->
                    <a href="https://twitter.com/news_oped" target="_blank" title="ツイッター">
                        <span class="fa-stack fa-lg">
                            <i class="fa fa-circle fa-stack-2x fa-inverse" aria-hidden="true"></i>
                            <i class="fa fa-twitter fa-stack-1x" aria-hidden="true"><span class="sr-only">ツイッター</span></i>
                        </span>
                    </a>
                </li>
                <li>
                    <!-- 以下のaタグを編集してください -->
                    <a href="https://www.facebook.com/news.oped/" target="_blank" title="フェイスブック">
                        <span class="fa-stack fa-lg">
                            <i class="fa fa-circle fa-stack-2x fa-inverse" aria-hidden="true"></i>
                            <i class="fa fa-facebook fa-stack-1x" aria-hidden="true"><span class="sr-only">フェイスブック</span></i>
                        </span>
                    </a>
                </li>
                <li>
                    <!-- 以下のaタグを編集してください -->
                    <a href="https://www.youtube.com/channel/UCGNduTqLENPjULlaSWGCNIA" target="_blank" title="ユーチューブ">
                        <span class="fa-stack fa-lg">
                            <i class="fa fa-circle fa-stack-2x fa-inverse" aria-hidden="true"></i>
                            <i class="fa fa-youtube-play fa-stack-1x" aria-hidden="true"><span class="sr-only">ユーチューブ</span></i>
                        </span>
                    </a>
                </li>
                <!-- <li>
                    <a href="https://www.instagram.com/" target="_blank" title="インスタグラム">
                        <span class="fa-stack fa-lg">
                            <i class="fa fa-circle fa-stack-2x fa-inverse" aria-hidden="true"></i>
                            <i class="fa fa-instagram fa-stack-1x" aria-hidden="true"><span class="sr-only">インスタグラム</span></i>
                        </span>
                    </a>
                </li>
                <li>
                    <a href="https://getpocket.com/" target="_blank" title="ポケット">
                        <span class="fa-stack fa-lg">
                            <i class="fa fa-circle fa-stack-2x fa-inverse" aria-hidden="true"></i>
                            <i class="fa fa-get-pocket fa-stack-1x" aria-hidden="true"><span class="sr-only">ポケット</span></i>
                        </span>
                    </a>
                </li> -->
            </ul>
        </div>
    </div>
</div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import MultiModalMixin from '../mixins/ModalMixin'

  export default {
    name: "MainMenu",
    mixins: [MultiModalMixin],
    data: function (){
        return {
            isLogged: OPED.isLogged,
        };
    }
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/vue/component/modal/main_menu.vue